import { StepType } from "../../../enums/course/step-type";
import { MultiChoiceQuestion } from "./multi-choice-question";

export declare class MultiChoiceAnswerSubmission {
  public type: StepType;
  public question: MultiChoiceQuestion;
  public answer?: number[];
  public isAnswered: boolean;
  public submittedAt: Date;
}